import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { QuestionnaireNodeComponent} from './questionnaire-node.component';
import { SmsModule } from '../sms/sms.module';
import { EmailModule} from '../email/email.module';
import { AddFileToDownloadModule} from '../../addFileDownload/add-file-to-download.module';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { NgxSelectModule } from 'ngx-select-ex';
import { GenericModalModule} from '../../modal/generic-modal.module';
import { ContentPreviewModule } from '../emailPreview/content-preview.module';
import { SendTestEmailModule } from '../emailTest/send-test-email.module';
import {ImportDuplicateModalModule} from '../../import-duplicate-modal/import-duplicate-modal.module';
import {FileChooserModule} from '../../FileChooser/file-chooser.module';
import {BreadCrumbModule} from '../../bread-crumb/bread-crumb.module';
import {FileUploadModule} from 'ng2-file-upload';
import {InformationSideBarModule} from '../../informationSideBar/information-side-bar.module';
import {SocialMedialContentDefinitionModule} from '../../socialMediaContentDefinition/social-medial-content-definition.module';
import {DatabaseModule} from '../../database/database.module';
import {FfmpegDefinitionModule} from '../../ffmpeg/ffmpegDefinition.module';
import {ImageMagicksDefinitionModule} from '../../imageMagicks/imageMagicksDefinition.module';
import {SharedRefreshService} from '../../service/sharedRefreshService';
import {RibbonModule} from '../../ribbon/ribbon.module';
import {EmailComposerModule} from '../emailComposer/email-composer.module';
import {MicrositeConfiguratorModule} from '../../micrositeAppearanceConfigurator/micrositeConfigurator.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SmsModule,
    EmailModule,
    AddFileToDownloadModule,
    NgxSelectModule,
    TranslatePipeModule,
    GenericModalModule,
    ContentPreviewModule,
    SendTestEmailModule,
    ImportDuplicateModalModule,
    FileChooserModule,
    BreadCrumbModule,
    FileUploadModule,
    InformationSideBarModule,
    SocialMedialContentDefinitionModule,
    DatabaseModule,
    FfmpegDefinitionModule,
    ImageMagicksDefinitionModule,
    RibbonModule,
    EmailComposerModule,
    MicrositeConfiguratorModule
  ],
  declarations: [
    QuestionnaireNodeComponent
  ],
  providers: [SharedRefreshService],
  exports: [
    QuestionnaireNodeComponent
  ]
})
export class QuestionnaireNodeModule {

}
